// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__85XlT","header":"MergedInvoice_header__3kDA1"};